"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var BrandsSmtpCfgCtl = /** @class */ (function (_super) {
    __extends(BrandsSmtpCfgCtl, _super);
    function BrandsSmtpCfgCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this._errDialog = errDialog;
        return _this;
    }
    BrandsSmtpCfgCtl.prototype.ResetData = function () {
        this.DATA = {
            smtp_server: "",
            smtp_port: 0,
            smtp_user: "",
            smtp_password: "",
            smtp_use_ssl: false,
            smtp_from_email: "",
            double_opt_in_via_unisender: false,
            unisender_apikey: "",
            is_unisender_add_on_verify_email: false,
            unisender_verify_email_player_tag: "",
            unisender_verify_email_player_group_id: 0,
            is_unisender_add_on_subscribe_email: false,
            unisender_subscribe_email_player_tag: "",
            unisender_subscribe_email_player_group_id: 0,
            is_unisender_move_mail_players_to_another_group: false,
            unisender_mail_payers_another_group_tag: "",
            unisender_mail_players_another_group_id: 0
        };
    };
    BrandsSmtpCfgCtl.prototype.LoadData = function (brand_key, onDone) {
        var _this = this;
        webAApi_1.DetailsBrandSmtpConfigGet.exec({ brand_id: brand_key }, function (resp) {
            _this.DATA.smtp_server = resp.smtp_server;
            _this.DATA.smtp_port = resp.smtp_port;
            _this.DATA.smtp_user = resp.smtp_user;
            _this.DATA.smtp_password = resp.smtp_password;
            _this.DATA.smtp_use_ssl = resp.smtp_use_ssl;
            _this.DATA.smtp_from_email = resp.smtp_from_email;
            _this.DATA.double_opt_in_via_unisender = resp.double_opt_in_via_unisender;
            _this.DATA.unisender_apikey = resp.unisender_apikey;
            _this.DATA.is_unisender_add_on_verify_email = resp.is_unisender_add_on_verify_email;
            _this.DATA.unisender_verify_email_player_tag = resp.unisender_verify_email_player_tag;
            _this.DATA.unisender_verify_email_player_group_id = resp.unisender_verify_email_player_group_id;
            _this.DATA.is_unisender_add_on_subscribe_email = resp.is_unisender_add_on_subscribe_email;
            _this.DATA.unisender_subscribe_email_player_tag = resp.unisender_subscribe_email_player_tag;
            _this.DATA.unisender_subscribe_email_player_group_id = resp.unisender_subscribe_email_player_group_id;
            _this.DATA.is_unisender_move_mail_players_to_another_group = resp.is_unisender_move_mail_players_to_another_group;
            _this.DATA.unisender_mail_payers_another_group_tag = resp.unisender_mail_payers_another_group_tag;
            _this.DATA.unisender_mail_players_another_group_id = resp.unisender_mail_players_another_group_id;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsSmtpCfgCtl.prototype.EditData = function (editData, onDone) {
        var _this = this;
        webAApi_1.DoEditBrandSmtpConfig.exec({
            data: {
                smtp_server: editData.smtp_server,
                smtp_port: editData.smtp_port,
                smtp_password: editData.smtp_password,
                smtp_use_ssl: editData.smtp_use_ssl,
                smtp_from_email: editData.smtp_from_email,
                smtp_user: editData.smtp_user,
                double_opt_in_via_unisender: editData.double_opt_in_via_unisender,
                unisender_apikey: editData.unisender_apikey,
                brand_id: editData.brand_id,
                is_unisender_add_on_verify_email: editData.is_unisender_add_on_verify_email,
                unisender_verify_email_player_tag: editData.unisender_verify_email_player_tag,
                unisender_verify_email_player_group_id: editData.unisender_verify_email_player_group_id,
                is_unisender_add_on_subscribe_email: editData.is_unisender_add_on_subscribe_email,
                unisender_subscribe_email_player_tag: editData.unisender_subscribe_email_player_tag,
                unisender_subscribe_email_player_group_id: editData.unisender_subscribe_email_player_group_id,
                is_unisender_move_mail_players_to_another_group: editData.is_unisender_move_mail_players_to_another_group,
                unisender_mail_payers_another_group_tag: editData.unisender_mail_payers_another_group_tag,
                unisender_mail_players_another_group_id: editData.unisender_mail_players_another_group_id
            }
        }, function (resp) {
            _this.DATA.smtp_server = editData.smtp_server;
            _this.DATA.smtp_port = editData.smtp_port;
            _this.DATA.smtp_user = editData.smtp_user;
            _this.DATA.smtp_password = editData.smtp_password;
            _this.DATA.smtp_use_ssl = editData.smtp_use_ssl;
            _this.DATA.smtp_from_email = editData.smtp_from_email;
            _this.DATA.double_opt_in_via_unisender = editData.double_opt_in_via_unisender;
            _this.DATA.unisender_apikey = editData.unisender_apikey;
            _this.DATA.is_unisender_add_on_verify_email = editData.is_unisender_add_on_verify_email,
                _this.DATA.unisender_verify_email_player_tag = editData.unisender_verify_email_player_tag,
                _this.DATA.unisender_verify_email_player_group_id = editData.unisender_verify_email_player_group_id,
                _this.DATA.is_unisender_add_on_subscribe_email = editData.is_unisender_add_on_subscribe_email,
                _this.DATA.unisender_subscribe_email_player_tag = editData.unisender_subscribe_email_player_tag,
                _this.DATA.unisender_subscribe_email_player_group_id = editData.unisender_subscribe_email_player_group_id,
                _this.DATA.is_unisender_move_mail_players_to_another_group = editData.is_unisender_move_mail_players_to_another_group;
            _this.DATA.unisender_mail_payers_another_group_tag = editData.unisender_mail_payers_another_group_tag;
            _this.DATA.unisender_mail_players_another_group_id = editData.unisender_mail_players_another_group_id;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return BrandsSmtpCfgCtl;
}(BaseController_1.BaseController));
exports.BrandsSmtpCfgCtl = BrandsSmtpCfgCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ctl/BrandSmtpCfgCtl.ts
// module id = 970
// module chunks = 0